export default {
  pageTitle: {
    id: 'models_comparison_page_title',
    defaultMessage: 'Compare models',
  },
  resultsTitle: {
    id: 'models_comparison_result_title',
    defaultMessage: '{firstModel} Vs {secondModel}',
  },
} as const
